(function() {

  (function($) {
    return $.extend($.fn, {
      window_open_blank: function() {
        return this.each(function() {
          if (!this.href.match(document.domain)) {
            return $(this).click(function() {
              window.open(this.href, 'blank').focus();
              return false;
            });
          }
        });
      },
      active: function(class_name) {
        if (class_name == null) {
          class_name = 'focus';
        }
        return this.each(function() {
          var el;
          el = $(this);
          if (location.href.match(el.attr('href'))) {
            return el.addClass(class_name);
          }
        });
      },
      round_image_corners: function(radius) {
        if (radius == null) {
          radius = '5px';
        }
        if ($.browser.msie && parseInt($.browser.version, 10) < 9) {
          return false;
        } else {
          return this.each(function() {
            var img;
            img = $(this);
            return img.images_loaded(function() {
              var div;
              div = $('<div>').attr('class', img.attr('class')).css({
                'width': img.width(),
                'height': img.height(),
                'background': "url('" + (img.attr('src')) + "') no-repeat 0 0",
                'border-radius': radius,
                '-moz-border-radius': radius,
                '-webkit-border-radius': radius
              });
              return img.replaceWith(div);
            });
          });
        }
      },
      loaded: function(callback, fireOne) {
        var $this, elems, total;
        $this = $(this);
        elems = this.filter('img');
        if (elems.size() === 0) {
          elems = $this.find('img');
        }
        total = elems.length - 1;
        return elems.bind('load', function(event) {
          if (fireOne) {
            return !total-- && callback.call($this, event);
          } else {
            return callback.call($this, event);
          }
        }).each(function() {
          var src;
          if (this.complete || this.complete === void 0) {
            src = this.src;
            this.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
            return this.src = src;
          }
        });
      },
      placeholder_support: function() {
        var supports_placeholder;
        supports_placeholder = function() {
          var i;
          i = document.createElement('input');
          return 'placeholder' in i;
        };
        return this.each(function() {
          var input, text;
          input = $(this);
          text = input.attr('placeholder');
          input.addClass('placeholder blur');
          if (text && supports_placeholder() === false) {
            return input.focus(function() {
              if (input.val() === text) {
                return input.val('').removeClass('blur');
              }
            }).blur(function() {
              if (input.val() === '') {
                return input.val(text).addClass('blur');
              }
            });
          }
        });
      },
      element_hover: function() {
        var handlers;
        handlers = {
          focus: function() {
            return $(this).addClass('hover').css('cursor', 'pointer');
          },
          blur: function() {
            return $(this).removeClass('hover').css('cursor', 'auto');
          },
          click: function() {
            window.location.href = $(this).find('a').attr('href');
            return false;
          }
        };
        return this.each(function() {
          return $(this).hover(handlers.focus, handlers.blur).click(handlers.click);
        });
      },
      spin: function(opts, color) {
        var presets;
        presets = {
          tiny: {
            lines: 8,
            length: 2,
            width: 2,
            radius: 3
          },
          small: {
            lines: 8,
            length: 4,
            width: 3,
            radius: 5
          },
          large: {
            lines: 10,
            length: 8,
            width: 4,
            radius: 8
          }
        };
        if (Spinner) {
          return this.each(function() {
            var $this, data;
            $this = $(this);
            data = $this.data();
            if (data.spinner) {
              data.spinner.stop();
              delete data.spinner;
            }
            if (opts !== false) {
              if (typeof opts === "string") {
                if (opts in presets) {
                  opts = presets[opts];
                } else {
                  opts = {};
                }
                if (color) {
                  opts.color = color;
                }
                opts.hwaccel = true;
              }
              return data.spinner = new Spinner($.extend({
                color: $this.css('color')
              }, opts)).spin(this);
            }
          });
        } else {
          throw "Spinner class not available.";
        }
      },
      center: function() {
        return this.each(function() {
          var element, parent;
          element = $(this);
          parent = element.parent();
          if (parent.css('position') === 'static') {
            parent.css('position', 'relative');
          }
          return element.css({
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: -(element.outerHeight(true) / 2) + 'px',
            marginLeft: -(element.outerWidth(true) / 2) + 'px'
          });
        });
      },
      tabinate: function(options) {
        var $this, defaults, nav, tabs;
        defaults = {
          tab_selector: '.tab',
          heading_selector: 'h3'
        };
        options = $.extend(defaults, options);
        $this = $(this);
        tabs = $this.find(options.tab_selector);
        nav = $('<ul>', {
          "class": 'navigation'
        });
        tabs.each(function() {
          var element, link, title;
          element = $(this);
          title = element.find('h3').text();
          link = $('<a>', {
            href: '#' + element.attr('id')
          }).text(title);
          nav.append($('<li>').html(link));
          return link.on('click', function(event) {
            nav.find('a').removeClass('focus');
            $(this).addClass('focus');
            tabs.hide();
            element.show();
            return event.preventDefault();
          });
        });
        return $this.prepend(nav);
      }
    });
  })(jQuery);

}).call(this);
